import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const areaChartTool: Tool = {
  id: "area-chart",
  name: () => m.area_tool_name(),
  description: () => m.area_tool_description(),
  icon: "📉",
  basePath: "/area-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "area-chart", "science"],
};
